module.exports = __webpack_public_path__ + "img/time-funnel_v4.a6b476de.png";